import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { sessionGetItemObj, sessionGetItemStr } from '../../../utils/sessionHelpers'
import { values } from 'lodash-es'
import CoworkerEvaluateYourselfWidget from '../../../widgets/evaluatesWidgets/coworkerEvaluateYourselfWidgets/CoworkerEvaluateYourselfWidget'
import { getProjectEvaluation } from '../../../redux/actions/projectEvaluation'

export default function CoworkerEvaluateYourself() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const subProjectCode = sessionGetItemStr('subProjectCode')
  const { periodNo } = sessionGetItemObj('subProjectPeriodInfo')
  const subIncomeId = sessionGetItemStr('subIncomeId')
  const projectVersionId = 'E13BFAB8-35BE-4C22-B8E6-6EC127AFF69E'
  const projectProgressId = '3062F0B2-C127-4746-A2CB-7BB16B522C94'
  const evaluationId = '0'

  // console.log('mockSchema2==>', mockSchema2.form)

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getProjectEvaluation(projectVersionId, projectProgressId, evaluationId)
      setSchema(response)
      // console.log('response==>', response)
      // setSchema(mockSchema2.form)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isEvaluates>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isEvaluates>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isEvaluates>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi isShowGoButton />

        <CoworkerEvaluateYourselfWidget schema={schema} />
        <br />
      </SidebarProposal>
    </div>
  )
}

const mockSchema = {
  affectedRows: 5,
  message: 'Successfully',
  success: true,
  didError: false,
  errorMessage: null,
  model: {
    header: 'การประเมินโดยภาคี',
    subHeader: '',
    disabled: false,
    form: {
      coworkerEvaluateThaihealth: {
        header: 'ผลการประเมินความพึงพอใจที่ภาคีมีต่อ สสส.',
        result: [
          {
            label:
              '1.ท่านได้รับการสนับสนุนจาก สสส.  เพื่อดำเนินงานโครงการนี้ในระดับใด อาทิ สสส. เข้ามาร่วมคิดร่วมวางแผนงาน การให้คำแนะนำปรึกษา ร่วมแก้ไขปัญหา ร่วมเวที/ลงพื้นที่ปฏิบัติงาน เป็นต้น',
            name: 'evaluateThaihealth1',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [
              { type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบในข้อนี้' },
            ],
          },
          {
            label: '2.ท่านมีความรู้สึกเป็นส่วนหนึ่งของขบวนการขับเคลื่อนสุขภาพของ สสส. ในระดับใด',
            name: 'evaluateThaihealth2',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [
              { type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบในข้อนี้' },
            ],
          },
          {
            label:
              '3.ในฐานะที่ท่านได้ร่วมงานกับทาง สสส. ท่านมีความสุข และมีแรงจูงใจในการดำเนินโครงการ/กิจกรรมอื่น ๆ ต่อไปในระดับใด',
            name: 'evaluateThaihealth3',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [
              { type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบในข้อนี้' },
            ],
          },
        ],
      },
      coworkerEvaluateYourself: {
        header: 'ภาคีประเมินตนเอง ด้านการบริหารจัดการโครงการ',
        result: [
          {
            label:
              '1.ท่านมีการวิเคราะห์โครงการและพัฒนาข้อเสนอโครงการได้อย่างมีคุณภาพมากน้อยเพียงใด',
            name: 'evaluateYourself1',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบ' }],
          },
          {
            label: '2.ท่านมีการวางแผนและบริหารโครงการได้เป็นอย่างดี บรรลุตามเป้าหมายมากน้อยเพียงใด',
            name: 'evaluateYourself2',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบ' }],
          },
          {
            label:
              '3.ท่านมีการนำนวัตกรรมมาประยุกต์ใช้ในการดำเนินโครงการ เพื่อก่อให้เกิดการทำงานที่มีประสิทธิภาพ ลดขั้นตอนการทำงาน และเพิ่มคุณค่าให้กับผู้มีส่วนได้ส่วนเสียในโครงการได้มากน้อยเพียงใด ',
            name: 'evaluateYourself3',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบ' }],
          },
          {
            label:
              '4.การดำเนินโครงการของท่านมีการเลือกกลุ่มเป้าหมาย/ ผู้มีส่วนได้ส่วนเสีย (Stakeholder) ที่น่าเชื่อถือและสมเหตุสมผลมากน้อยเพียงใด',
            name: 'evaluateYourself4',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'เลือกจากเป้าหมายของโครงการ',
                value: '1',
              },
              {
                disabled: false,
                label: 'เลือกจากคำแนะนำของ สสส.',
                value: '2',
              },
              {
                disabled: false,
                label: 'เลือกจากคำแนะนำของผู้บังคับบัญชา',
                value: '3',
              },
              {
                disabled: false,
                label: 'เลือกจากคำแนะนำของคนใกล้ตัว',
                value: '4',
              },
              {
                disabled: false,
                label: 'เลือกจากคนใกล้ตัว',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบ' }],
          },
          {
            label:
              '5.ท่านมีการวัดและติดตามประเมินผลสำเร็จโครงการ เพื่อพัฒนายกระดับงานอย่างต่อเนื่องมากน้อยเพียงใด',
            name: 'evaluateYourself5',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบ' }],
          },
          {
            label:
              '6.โครงการของท่านมีผลลัพธ์หรือผลผลิตที่สอดคล้องกับเป้าหมายของโครงการ มากน้อยเพียงใด',
            name: 'evaluateYourself6',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบ' }],
          },
          {
            label:
              '7.ท่านสามารถปฏิบัติตามกฎระเบียบที่เกี่ยวข้องกับการบริหารจัดการโครงการของ สสส. มากน้อยเพียงใด',
            name: 'evaluateYourself7',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบ' }],
          },
          {
            label:
              '8.ท่านมีความส่วนร่วมในทุกกิจกรรมของโครงการมากน้อยเพียงใด (สามารถเลือกได้มากกว่า 1 ข้อ)',
            name: 'evaluateYourself8',
            value: [],
            disabled: false,
            inputType: 'CHECKBOX',
            options: [
              {
                disabled: false,
                label: 'ถอดบทเรียน',
                value: '1',
              },
              {
                disabled: false,
                label: 'ร่วมคิดและวางแผน',
                value: '2',
              },
              {
                disabled: false,
                label: 'ร่วมดำเนินการ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ร่วมประเมิน',
                value: '4',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบ' }],
          },
          {
            label:
              '9.ท่านสามารถส่งมอบงานตามข้อเสนอโครงการ ให้แก่ สสส. ได้ร้อยละเท่าใด (สามารถตอบได้มากกว่า 100% ถ้าส่งงานได้มากกว่าที่กำหนดในข้อตกลง)',
            name: 'evaluateYourself9',
            value: '',
            disabled: false,
            inputType: 'INPUTNUMBER',
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกข้อมูล' }],
          },
          {
            label:
              '10.ท่านคิดว่าเมื่อเทียบผลผลิตกับงบประมาณของโครงการแล้ว ผลผลิตของท่านมีความคุ้มค่าคิดเป็นร้อยละเท่าใดของงบประมาณ (สามารถตอบเกิน 100% ได้)',
            name: 'evaluateYourself10',
            value: '',
            disabled: false,
            inputType: 'INPUTNUMBER',
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกข้อมูล' }],
          },
        ],
      },
    },
  },
}

const mockSchema2 = {
  affectedRows: 5,
  message: 'Successfully',
  success: true,
  didError: false,
  errorMessage: null,
  header: 'การประเมินโดยภาคี',
  subHeader: '',
  disabled: false,
  form: {
    header: 'การประเมินโดยภาคี',
    evaluations: [
      {
        code: 'UE1',
        name: 'ผลการประเมินความพึงพอใจที่ภาคีมีต่อ สสส.',
        questions: [
          {
            label:
              '1.ท่านได้รับการสนับสนุนจาก สสส.  เพื่อดำเนินงานโครงการนี้ในระดับใด อาทิ สสส. เข้ามาร่วมคิดร่วมวางแผนงาน การให้คำแนะนำปรึกษา ร่วมแก้ไขปัญหา ร่วมเวที/ลงพื้นที่ปฏิบัติงาน เป็นต้น',
            name: 'evaluateThaihealth1',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [
              { type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบในข้อนี้' },
            ],
          },
          {
            label: '2.ท่านมีความรู้สึกเป็นส่วนหนึ่งของขบวนการขับเคลื่อนสุขภาพของ สสส. ในระดับใด',
            name: 'evaluateThaihealth2',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [
              { type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบในข้อนี้' },
            ],
          },
          {
            label:
              '3.ในฐานะที่ท่านได้ร่วมงานกับทาง สสส. ท่านมีความสุข และมีแรงจูงใจในการดำเนินโครงการ/กิจกรรมอื่น ๆ ต่อไปในระดับใด',
            name: 'evaluateThaihealth3',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [
              { type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบในข้อนี้' },
            ],
          },
        ],
      },
      {
        code: 'UE2',
        name: 'ภาคีประเมินตนเอง ด้านการบริหารจัดการโครงการ',
        questions: [
          {
            label:
              '1.ท่านมีการวิเคราะห์โครงการและพัฒนาข้อเสนอโครงการได้อย่างมีคุณภาพมากน้อยเพียงใด',
            name: 'evaluateYourself1',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบ' }],
          },
          {
            label: '2.ท่านมีการวางแผนและบริหารโครงการได้เป็นอย่างดี บรรลุตามเป้าหมายมากน้อยเพียงใด',
            name: 'evaluateYourself2',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบ' }],
          },
          {
            label:
              '3.ท่านมีการนำนวัตกรรมมาประยุกต์ใช้ในการดำเนินโครงการ เพื่อก่อให้เกิดการทำงานที่มีประสิทธิภาพ ลดขั้นตอนการทำงาน และเพิ่มคุณค่าให้กับผู้มีส่วนได้ส่วนเสียในโครงการได้มากน้อยเพียงใด ',
            name: 'evaluateYourself3',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบ' }],
          },
          {
            label:
              '4.การดำเนินโครงการของท่านมีการเลือกกลุ่มเป้าหมาย/ ผู้มีส่วนได้ส่วนเสีย (Stakeholder) ที่น่าเชื่อถือและสมเหตุสมผลมากน้อยเพียงใด',
            name: 'evaluateYourself4',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'เลือกจากเป้าหมายของโครงการ',
                value: '1',
              },
              {
                disabled: false,
                label: 'เลือกจากคำแนะนำของ สสส.',
                value: '2',
              },
              {
                disabled: false,
                label: 'เลือกจากคำแนะนำของผู้บังคับบัญชา',
                value: '3',
              },
              {
                disabled: false,
                label: 'เลือกจากคำแนะนำของคนใกล้ตัว',
                value: '4',
              },
              {
                disabled: false,
                label: 'เลือกจากคนใกล้ตัว',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบ' }],
          },
          {
            label:
              '5.ท่านมีการวัดและติดตามประเมินผลสำเร็จโครงการ เพื่อพัฒนายกระดับงานอย่างต่อเนื่องมากน้อยเพียงใด',
            name: 'evaluateYourself5',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบ' }],
          },
          {
            label:
              '6.โครงการของท่านมีผลลัพธ์หรือผลผลิตที่สอดคล้องกับเป้าหมายของโครงการ มากน้อยเพียงใด',
            name: 'evaluateYourself6',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบ' }],
          },
          {
            label:
              '7.ท่านสามารถปฏิบัติตามกฎระเบียบที่เกี่ยวข้องกับการบริหารจัดการโครงการของ สสส. มากน้อยเพียงใด',
            name: 'evaluateYourself7',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบ' }],
          },
          {
            label:
              '8.ท่านมีความส่วนร่วมในทุกกิจกรรมของโครงการมากน้อยเพียงใด (สามารถเลือกได้มากกว่า 1 ข้อ)',
            name: 'evaluateYourself8',
            value: [],
            disabled: false,
            inputType: 'CHECKBOX',
            options: [
              {
                disabled: false,
                label: 'ถอดบทเรียน',
                value: '1',
              },
              {
                disabled: false,
                label: 'ร่วมคิดและวางแผน',
                value: '2',
              },
              {
                disabled: false,
                label: 'ร่วมดำเนินการ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ร่วมประเมิน',
                value: '4',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบ' }],
          },
          {
            label:
              '9.ท่านสามารถส่งมอบงานตามข้อเสนอโครงการ ให้แก่ สสส. ได้ร้อยละเท่าใด (สามารถตอบได้มากกว่า 100% ถ้าส่งงานได้มากกว่าที่กำหนดในข้อตกลง)',
            name: 'evaluateYourself9',
            value: '',
            disabled: false,
            inputType: 'INPUTNUMBER',
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกข้อมูล' }],
          },
          {
            label:
              '10.ท่านคิดว่าเมื่อเทียบผลผลิตกับงบประมาณของโครงการแล้ว ผลผลิตของท่านมีความคุ้มค่าคิดเป็นร้อยละเท่าใดของงบประมาณ (สามารถตอบเกิน 100% ได้)',
            name: 'evaluateYourself10',
            value: '',
            disabled: false,
            inputType: 'INPUTNUMBER',
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกข้อมูล' }],
          },
        ],
      },
    ],
  },
}
